import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Route, Switch, useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import { AppTopbar } from './AppTopbar';
import { AppConfig } from './AppConfig';

import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';

import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './assets/demo/flags/flags.css';
import './assets/demo/Demos.scss';
import './assets/layout/layout.scss';
import './App.scss';
import Products from './app/features/screens/products/pages/Products';
import Faqs from './app/features/screens/faqs/pages/Faqs';
import ManageProduct from './app/features/screens/ManageProduct.js/pages/ManageProduct';
import ManageFaq from './app/features/screens/ManageFaq/pages/ManageFaq';
import Dashboard from './app/features/screens/Dashboard/pages/Dashboard';
import UserProcess from './app/features/screens/UserProcess/pages/UserProcess';
import UserComplaint from './app/features/screens/UserComplaint/pages/UserComplaint';
import UserSocialMedia from './app/features/screens/UserSocialMedia/pages/UserSocialMedia';
import AgainstProductProcess from './app/features/screens/AgainstProductProcess/pages/AgainstProductProcess';
import UserChat from './app/features/screens/UserChat/pages/UserChat';
import LoginScreen from './app/features/screens/auth/pages/login_screen';
import login_screen from './app/features/screens/auth/pages/login_screen';
import AdminZProduct from './app/features/screens/AdminZProduct/pages/AdminZProduct';
import AdminZAppJourney from './app/features/screens/AdminZAppJourney/pages/AdminZAppJourney';
import AdminZTrainingMaterial from './app/features/screens/AdminZTrainingMaterial/pages/AdminZTrainingMaterial';
import AdminTipOfDay from './app/features/screens/AdminTipOfDay/pages/AdminTipOfDay';
import AdminOutage from './app/features/screens/AdminOutage/pages/AdminOutage';
import AdminDisclaimer from './app/features/screens/AdminDisclaimer/pages/AdminDisclaimer';
import AdminDashboardSlider from './app/features/screens/AdminDashboardSlider/pages/AdminDashboardSlider';

const App = () => {
    const [layoutMode, setLayoutMode] = useState('static');
    const [layoutColorMode, setLayoutColorMode] = useState('light')
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const copyTooltipRef = useRef();
    const location = useLocation();

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    }

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value)
    }

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode)
    }

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode)
    }

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    }

    const onToggleMenuClick = (event) => {

        console.log('clicked', event)
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === 'overlay') {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive((prevState) => !prevState);
            }
        }
        else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    }

    const onSidebarClick = () => {
        menuClick = true;
    }

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    }

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }
    const isDesktop = () => {
        return window.innerWidth >= 992;
    }

    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false,
        'layout-theme-light': layoutColorMode === 'light'
    });
   

    return (
        
        <div className={wrapperClass} onClick={onWrapperClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

            <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode}
                mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />

            {/* <div className="layout-sidebar" onClick={onSidebarClick}>
                <AppMenu  onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
            </div> */}

            <div className="layout-main-container">
                <div className="layout-main">
                <AppTopbar />
                    <Switch>
                        <Route exact path="/" component={LoginScreen } />
                        <Route exact path="/adminzproduct" component={AdminZProduct } />
                        <Route exact path="/adminzapplourney" component={AdminZAppJourney } />
                        <Route exact path="/adminztrainingmaterial" component={AdminZTrainingMaterial } />
                        <Route exact path="/admintipofday" component={AdminTipOfDay } />
                        <Route exact path="/adminoutage" component={AdminOutage } />
                        <Route exact path="/admindisclaimer" component={AdminDisclaimer } />
                        <Route exact path="/admindashboardslider" component={AdminDashboardSlider } />
                        <Route exact path="/home" component={Products} />
                        <Route exact path="/userprocess" component={UserProcess} />
                        <Route exact path="/usersocialmedia" component={UserSocialMedia} />
                        <Route exact path="/faq" component={ManageFaq} />
                        <Route exact path="/againstproductprocess" component={AgainstProductProcess} />
                        <Route exact path="/dashboard" component={Dashboard} />
                        <Route exact path="/product" component={ManageProduct} />
                        <Route exact path="/userfaq" component={Faqs} />
                        <Route exact path="/userchat" component={UserChat} />
                        <Route exact path="/usercomplaint" component={UserComplaint} />
                      
                    </Switch>
                </div>

                {/* <AppFooter layoutColorMode={layoutColorMode} /> */}
            </div>

            <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange}
                layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />

            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>

        </div>
    );

}

export default App;
